import { Chat, SmartFolder, UserProfile, ScheduledMessage } from '../types/messenger';

export const currentUser: UserProfile = {
  id: 'user_me',
  name: 'Кирило Милосердов',
  handle: '@kirill_m',
  avatar: '',
  status: 'Фокус над архітектурою та просторами',
  statusEmoji: '⚡',
  bio: 'Product Designer & Architect. Досліджую ергономіку інтерфейсів, органічну типографіку та міські простори.',
  phone: '+380 97 452 1890',
  locationName: 'Київ · Поділ / Лук’янівка',
  batteryLevel: 94,
  isMutedAlerts: false,
  circleRole: 'Creator & Core Lead',
  personalNotes: 'Головний робочий профіль.',
  activePersonaSphere: 'work',
  storageUsageMb: {
    media: 640,
    files: 310,
    voice: 145,
    cache: 85,
  },
  // Реєстру сеансів немає — вигадані підключення до акаунта показувати не можна.
  activeDevices: [],
  personas: {
    work: {
      id: 'work',
      title: 'Робоча сфера (Product & Core)',
      name: 'Кирило Милосердов',
      handle: '@kirill_m',
      statusText: 'У процесі проектування v2.5',
      statusEmoji: '⚡',
      bio: 'Lead Product Designer & UI/UX Architect. Спеціалізуюся на дизайн-системах, ергономіці інтерфейсів та SaaS-інструментах.',
      jobTitle: 'Lead Product Designer',
      company: 'Aura Studio & Labs',
      pronouns: 'він/його',
      workHours: '10:00 – 19:00 (Пн-Пт)',
      timezone: 'Київ (UTC+2 / EET)',
      locationName: 'Київ · Поділ',
      tags: ['UI/UX', 'Design Systems', 'TypeScript', 'SaaS Architecture', 'Figma Tokens'],
      links: [
        { title: 'Figma Community', url: 'https://figma.com/@kirill' },
        { title: 'GitHub Repository', url: 'https://github.com/kirill-m' },
        { title: 'Особисте портфоліо', url: 'https://kirill.design' },
      ],
      phoneVisibility: 'contacts',
      lastSeenVisibility: 'everyone',
    },
    personal: {
      id: 'personal',
      title: 'Особисте коло',
      name: 'Кирило',
      handle: '@kirill_life',
      statusText: 'Кава на Подолі ☕',
      statusEmoji: '🌿',
      bio: 'Любитель фільтр-кави, велопрогулянок старим Києвом, аналогової фотографії та електронної музики.',
      jobTitle: 'Киянин & Дослідник міст',
      company: 'Поділ / Воздвиженка',
      pronouns: 'він/його',
      workHours: 'Вільний графік',
      timezone: 'Київ (UTC+2)',
      locationName: 'Київ · Поділ',
      tags: ['Київ', 'Фільтр-кава', 'Вело', 'Аналогове фото', 'Урбаністика'],
      links: [
        { title: 'Instagram', url: 'https://instagram.com/kirill_lens' },
        { title: 'Spotify Vibes', url: 'https://open.spotify.com' },
      ],
      phoneVisibility: 'contacts',
      lastSeenVisibility: 'contacts',
    },
    creative: {
      id: 'creative',
      title: 'Творчість & Арт-лабораторія',
      name: 'Kirill M. (Studio)',
      handle: '@kirill_creative',
      statusText: 'Експерименти з typography & sound',
      statusEmoji: '🎨',
      bio: 'Звуковий дизайн, генеративна графіка, 3D візуалізація та айдентика для культурних ініціатив.',
      jobTitle: 'Sound & Visual Artist',
      company: 'Independent Studio',
      pronouns: 'he/him',
      workHours: 'Нічні сесії & Вихідні',
      timezone: 'Kyiv (UTC+2)',
      locationName: 'Київ · Арт-завод Платформа',
      tags: ['Sound Design', 'Generative Art', 'Blender 3D', 'Ableton Live', 'Micro-typography'],
      links: [
        { title: 'Behance Portfolio', url: 'https://behance.net/kirill' },
        { title: 'SoundCloud Tracks', url: 'https://soundcloud.com' },
      ],
      phoneVisibility: 'nobody',
      lastSeenVisibility: 'nobody',
    },
    family: {
      id: 'family',
      title: 'Родина & Дім',
      name: 'Кирило',
      handle: '@kirill_home',
      statusText: 'Вдома з родиною 🏡',
      statusEmoji: '💛',
      bio: 'Сімейний контакт, спільні домашні плани, свята та важливі справи.',
      jobTitle: 'Син / Брат',
      company: 'Родинний простір',
      pronouns: 'він/його',
      workHours: 'Завжди на зв’язку для рідних',
      timezone: 'Київ (UTC+2)',
      locationName: 'Київ · Лук’янівка',
      tags: ['Родина', 'Дім', 'Спільні поїздки'],
      phoneVisibility: 'everyone',
      lastSeenVisibility: 'everyone',
    },
    academy: {
      id: 'academy',
      title: 'Навчання & Академія',
      name: 'Кирило М. (Student/Researcher)',
      handle: '@kirill_edu',
      statusText: 'Підготовка до сесії & Research 📚',
      statusEmoji: '🎓',
      bio: 'Дослідник у сфері P2P-алгоритмів, CRDT та розподілених обчислень. Навчальна група та наукові семінари.',
      jobTitle: 'CS Student & Researcher',
      company: 'Київський політехнічний інститут',
      pronouns: 'він/його',
      workHours: '08:30 – 17:00',
      timezone: 'Київ (UTC+2)',
      locationName: 'Київ · Політех',
      tags: ['Computer Science', 'Distributed Systems', 'CRDT', 'LaTeX', 'Algorithms'],
      phoneVisibility: 'contacts',
      lastSeenVisibility: 'contacts',
    },
    community: {
      id: 'community',
      title: 'Спільноти & Клуби',
      name: 'Кирило (Community Voice)',
      handle: '@kirill_civic',
      statusText: 'Урбаністичні та клубні ініціативи 🌿',
      statusEmoji: '🌐',
      bio: 'Координатор місцевих проектів, активіст урбан-ініціатив та учасник книжкового клубу.',
      jobTitle: 'Community Organizer',
      company: 'Подільська урбан-спільнота',
      pronouns: 'він/його',
      workHours: 'Гнучкий графік',
      timezone: 'Київ (UTC+2)',
      locationName: 'Київ · Поділ',
      tags: ['Урбаністика', 'Книжковий клуб', 'Громадські ініціативи', 'Civic Tech'],
      phoneVisibility: 'everyone',
      lastSeenVisibility: 'everyone',
    },
  },
};

export const initialChats: Chat[] = [
  // 1. WORK CIRCLE: Aura Architecture & Design
  {
    id: 'chat_aura_design',
    title: 'Aura Architecture & Core ⚡',
    avatar: '',
    type: 'group',
    circle: 'work',
    badge: 'Спринт 4',
    pinned: true,
    unreadCount: 2,
    membersCount: 6,
    customVibe: 'Робочий простір дизайн-системи, аналітики та архітектури',
    description: 'Командний хаб розробки новітнього інтерфейсу, органічних компонентів, таблиць та діаграм.',
    topic: 'Синхронізація релізу v2.4 та впровадження інтерактивних модулів',
    isPublic: false,
    publicHandle: '@aura_core_team',
    isForum: true,
    slowModeSeconds: 0,
    autoDeleteSeconds: 0,
    historyVisibilityForNewMembers: 'visible',
    allowedReactions: 'all',
    permissions: {
      sendMessages: true,
      sendMedia: true,
      sendStickersAndGifs: true,
      sendPolls: true,
      embedLinks: true,
      addMembers: true,
      pinMessages: true,
      changeChatInfo: false,
    },
    topics: [
      { id: 't_general', title: 'Загальне обговорення', iconEmoji: '💬', color: '#E87A42', messageCount: 142, lastMessageText: 'Синхронізація релізу v2.4' },
      { id: 't_design', title: 'Дизайн-система & Токени', iconEmoji: '🎨', color: '#528A4B', messageCount: 89, lastMessageText: 'Оновлено кольори палітри' },
      { id: 't_releases', title: 'Спринти & Архітектура', iconEmoji: '⚡', color: '#8C461A', messageCount: 34, lastMessageText: 'Закриття таблиць та графіків' },
    ],
    inviteLinks: [
      { id: 'inv_1', code: 't.me/+aura_core_team', label: 'Основне посилання команди', creatorName: 'Кирило Милосердов', createdAt: '10.01.2026', usageCount: 6, usageLimit: 20, requireAdminApproval: false, isPrimary: true },
      { id: 'inv_2', code: 't.me/+join_aura_qa_review', label: 'Тестувальники та рев’юери', creatorName: 'Кирило Милосердов', createdAt: '15.02.2026', usageCount: 2, usageLimit: 5, requireAdminApproval: true }
    ],
    pendingJoinRequests: [
      { id: 'req_1', userId: 'u_andriy', userName: 'Андрій Швець', userAvatar: '', userBio: 'iOS розробник, хочу протестувати WebRTC ефіри та інтерактивні таблиці', requestedAt: 'Сьогодні о 10:14', sphereNote: 'Запрошений через рев’ю посилання' }
    ],
    auditLogs: [
      { id: 'a1', actorName: 'Олексій Коваленко', actorAvatar: '', action: 'Закріплено повідомлення', detail: 'Дорожня карта релізу v2.4', timestamp: '11:20' },
      { id: 'a2', actorName: 'Кирило Милосердов', actorAvatar: '', action: 'Оновлено тему бесіди', detail: 'Синхронізація релізу v2.4 та впровадження інтерактивних модулів', timestamp: '10:45' }
    ],
    sharedLinks: [
      { id: 'l1', url: 'https://github.com/aura-messenger/core', title: 'Aura Core Repository', domain: 'github.com', timestamp: '10:30', senderName: 'Олексій' },
      { id: 'l2', url: 'https://figma.com/@aura/design-system', title: 'Aura Organic UI Tokens', domain: 'figma.com', timestamp: '11:15', senderName: 'Кирило' }
    ],
    sharedMediaCount: {
      photos: 42,
      files: 19,
      links: 56,
      audio: 8,
      tables: 14,
    },
    members: [
      {
        id: 'user_me',
        name: 'Кирило Милосердов',
        handle: '@kirill_m',
        avatar: '',
        role: 'owner',
        customTitle: 'Lead Product Designer',
        statusText: 'Фокус над концепцією',
        isOnline: true,
        phone: '+380 97 452 1890',
        bio: 'Дизайн-системи та продуктова стратегія.',
      },
      {
        id: 'u_oleksiy',
        name: 'Олексій Коваленко',
        handle: '@oleksiy_dev',
        avatar: '',
        role: 'admin',
        customTitle: 'Lead Architect',
        statusText: 'Оптимізація Web Audio & синхронізація',
        isOnline: true,
        phone: '+380 67 112 3344',
        bio: 'Full-stack архітектор, любитель чистого TypeScript та системної стабільності.',
      },
      {
        id: 'u_daryna',
        name: 'Дарина Мельник',
        handle: '@daryna_qa',
        avatar: '',
        role: 'member',
        customTitle: 'Design QA & UX Research',
        statusText: 'Тестую мульти-цитування та таблиці',
        isOnline: true,
        phone: '+380 50 998 7766',
        bio: 'UX тестування, мобільна ергономіка та доступність (WCAG AA).',
      },
      {
        id: 'u_vlad',
        name: 'Владислав Руденко',
        handle: '@vlad_backend',
        avatar: '',
        role: 'member',
        customTitle: 'Backend Engineer',
        statusText: 'Реалтайм вебсокети',
        isOnline: false,
        phone: '+380 63 445 2211',
        bio: 'Інтеграція високопродуктивних реалтайм протоколів та сховища.',
      },
    ],
    messages: [
      {
        id: 'msg_w0_pin',
        senderId: 'u_oleksiy',
        senderName: 'Олексій Коваленко',
        senderAvatar: '',
        timestamp: '14:30',
        type: 'text',
        isPinned: true,
        text: '✨ Оголошення: Спільний реліз-спринт v2.4 призначено на цю п\'ятницю. Будь ласка, перевірте свій статус у зведеній таблиці нижче.',
        reactions: [
          { emoji: '👍', count: 4, users: ['user_me', 'u_daryna', 'u_vlad'] },
          { emoji: '🔥', count: 2, users: ['user_me', 'u_igor'] },
          { emoji: '✅', count: 1, users: ['u_daryna'] },
        ],
      },
      {
        id: 'msg_w1',
        senderId: 'u_igor',
        senderName: 'Ігор Ткаченко',
        senderAvatar: '',
        timestamp: '14:45',
        type: 'text',
        text: 'Всім привіт! Оновив схему редагування інтерактивних таблиць прямо всередині повідомлень. Можна редагувати значення клітинок, додавати рядки та вивантажувати в CSV 🚀',
        reactions: [{ emoji: '🚀', count: 3, users: ['user_me', 'u_oleksiy', 'u_daryna'] }],
      },
      {
        id: 'msg_w2',
        senderId: 'u_oleksiy',
        senderName: 'Олексій Коваленко',
        senderAvatar: '',
        timestamp: '15:02',
        type: 'table',
        text: 'Ось актуальний звіт по модулях та готовності релізу:',
        tableData: {
          title: 'Звіт готовності модулів до релізу',
          description: 'Aura Architecture & Core · Спринт v2.4',
          columns: [
            { key: 'task', label: 'Модуль / Задача', type: 'text' },
            { key: 'assignee', label: 'Відповідальний', type: 'text' },
            { key: 'status', label: 'Статус', type: 'badge' },
            { key: 'deadline', label: 'Дедлайн', type: 'text' },
          ],
          rows: [
            { id: 't1', task: 'Інтерактивні таблиці', assignee: 'Кирило', status: 'Готово', deadline: '—' },
            { id: 't2', task: 'Надійне пінкоді', assignee: 'Олексій', status: 'В процесі', deadline: 'Буде через 10 кв' },
            { id: 't3', task: 'Всі перевірки, super', assignee: 'Ігор', status: 'Рев\'ю', deadline: 'Дьюко' },
          ],
        },
        reactions: [{ emoji: '🧡', count: 4, users: ['user_me', 'u_igor', 'u_daryna'] }],
      },
      {
        id: 'msg_w3',
        senderId: 'u_daryna',
        senderName: 'Дарина Мельник',
        senderAvatar: '',
        timestamp: '11:28',
        type: 'chart',
        text: 'Зібрала щоденну динаміку закриття завдань та тестування за 7 днів:',
        chartData: {
          title: 'Швидкість розробки та закриття завдань',
          type: 'bar',
          data: [
            { name: 'Пн', tasks: 12, tests: 18 },
            { name: 'Вт', tasks: 19, tests: 24 },
            { name: 'Ср', tasks: 28, tests: 35 },
            { name: 'Чт', tasks: 22, tests: 30 },
            { name: 'Пт', tasks: 34, tests: 42 },
            { name: 'Сб', tasks: 16, tests: 20 },
            { name: 'Нд', tasks: 9, tests: 12 },
          ],
          keys: [
            { key: 'tasks', label: 'Закриті задачі', color: '#E87A42' },
            { key: 'tests', label: 'Тести UX', color: '#528A4B' },
          ],
          takeaway: 'Продуктивність зросла на 28% після оновлення інтерактивних інструментів.',
        },
      },
      {
        id: 'msg_w4',
        senderId: 'u_oleksiy',
        senderName: 'Олексій Коваленко',
        senderAvatar: '',
        timestamp: '11:32',
        type: 'code',
        codeData: {
          language: 'typescript',
          title: 'InteractiveTableEngine.ts',
          code: `export interface TableRow {\n  id: string;\n  values: Record<string, string | number>;\n  status: 'active' | 'completed' | 'blocked';\n}\n\nexport function calculateColumnSum(rows: TableRow[], columnKey: string): number {\n  return rows.reduce((acc, row) => acc + (Number(row.values[columnKey]) || 0), 0);\n}`,
        },
      },
      {
        id: 'msg_w5',
        senderId: 'u_daryna',
        senderName: 'Дарина Мельник',
        senderAvatar: '',
        timestamp: '11:35',
        type: 'file',
        fileData: {
          name: 'Aura_v2.4_Sprint_Specification.pdf',
          size: '2.8 МБ',
          extension: 'pdf',
          downloadCount: 14,
        },
      },
    ],
  },

  // 2. FAMILY CIRCLE: Рідний Дім 🏡
  {
    id: 'chat_family_home',
    title: 'Рідний Дім 🏡',
    avatar: '',
    type: 'group',
    circle: 'family',
    badge: 'Сім’я',
    pinned: true,
    unreadCount: 1,
    membersCount: 4,
    customVibe: 'Затишок, родинні справи, спільні покупки та плани',
    description: 'Чат сім’ї Милосердових. Спільні покупки, планування вихідних на дачі та фотографії.',
    topic: 'Вечеря в неділю та підготовка до збору яблук 🍏',
    sharedLinks: [
      { id: 'l_f1', url: 'https://gardening-guide.ua/apples', title: 'Поради з догляду за яблуневим садом', domain: 'gardening-guide.ua', timestamp: 'Вчора', senderName: 'Тато' }
    ],
    sharedMediaCount: {
      photos: 184,
      files: 8,
      links: 22,
      audio: 45,
      tables: 6,
    },
    members: [
      {
        id: 'u_mom',
        name: 'Мама (Олена Іванівна)',
        handle: '@olena_home',
        avatar: '',
        role: 'owner',
        customTitle: 'Мама 🌸',
        statusText: 'Печу пиріг з яблуками та корицею',
        isOnline: true,
        phone: '+380 50 123 4567',
        bio: 'Люблю квіти, кулінарію та сімейні подорожі.',
      },
      {
        id: 'u_dad',
        name: 'Тато (Віктор Сергійович)',
        handle: '@viktor_m',
        avatar: '',
        role: 'admin',
        customTitle: 'Тато 🛠️',
        statusText: 'На дачі, лагоджу терасу',
        isOnline: false,
        phone: '+380 67 234 5678',
        bio: 'Інженерія, садівництво та книги про історію.',
      },
      {
        id: 'u_sister',
        name: 'Дарина (Сестра)',
        handle: '@daryna_sis',
        avatar: '',
        role: 'member',
        customTitle: 'Сестричка 🎨',
        statusText: 'На парах в університеті',
        isOnline: true,
        phone: '+380 93 345 6789',
        bio: 'Студентка факультету архітектури.',
      },
      {
        id: 'user_me',
        name: 'Кирило Милосердов',
        handle: '@kirill_m',
        avatar: '',
        role: 'member',
        customTitle: 'Син ✦',
        statusText: 'В місті, заїду в магазин',
        isOnline: true,
        phone: '+380 97 452 1890',
        bio: 'Lead Designer.',
      },
    ],
    messages: [
      {
        id: 'msg_f1',
        senderId: 'u_mom',
        senderName: 'Мама (Олена Іванівна)',
        senderAvatar: '',
        timestamp: '09:10',
        type: 'voice',
        voiceData: {
          duration: 18,
          waveform: [20, 35, 60, 80, 75, 40, 25, 60, 90, 85, 50, 30, 45, 70, 55, 30, 20, 15],
          transcript: 'Кириле, доброго ранку! Заїдеш сьогодні після роботи до нас? Я спекла яблучний пиріг, і тато передав свіжий мед із пасіки.',
          summary: 'Мама запрошує на яблучний пиріг та передає домашній мед.',
        },
        reactions: [{ emoji: '🧡', count: 3, users: ['user_me', 'u_sister'] }],
      },
      {
        id: 'msg_f2',
        senderId: 'u_mom',
        senderName: 'Мама (Олена Іванівна)',
        senderAvatar: '',
        timestamp: '09:12',
        type: 'task-list',
        text: 'Склала список того, що потрібно докупити до недільного обіду:',
        taskListData: {
          title: 'Список покупок до родинного обіду 🛒',
          tasks: [
            { id: 'tk1', title: 'Органічне вершкове масло 82%', completed: true, assigneeName: 'Кирило' },
            { id: 'tk2', title: 'Волоські горіхи та мигдаль для випічки', completed: false, assigneeName: 'Дарина' },
            { id: 'tk3', title: 'Свіжий розмарин та базилік', completed: false, assigneeName: 'Кирило' },
            { id: 'tk4', title: 'Крафтовий сир із ферми', completed: true, assigneeName: 'Тато' },
          ],
        },
      },
      {
        id: 'msg_f3',
        senderId: 'user_me',
        senderName: 'Кирило Милосердов',
        senderAvatar: '',
        timestamp: '09:25',
        type: 'text',
        isSelf: true,
        text: 'Обов’язково заїду близько 18:30! Заскочу в маркет і куплю горіхи та свіжий базилік. До зустрічі! 🥐',
        reactions: [{ emoji: '✨', count: 2, users: ['u_mom', 'u_sister'] }],
      },
    ],
  },

  // 3. FRIENDS CIRCLE: Kyiv Explorers & Specialty ☕
  {
    id: 'chat_kyiv_explorers',
    title: 'Kyiv Explorers & Specialty ☕',
    avatar: '',
    type: 'group',
    circle: 'friends',
    badge: 'Друзі',
    pinned: true,
    unreadCount: 0,
    membersCount: 5,
    customVibe: 'Спешелті кава, пішохідні маршрути та архітектура Києва',
    description: 'Коло близьких друзів для досліджень нових закладів, терас, виставок та спільних прогулянок.',
    topic: 'Зустріч на терасі біля Всеволода Змієнка 🌿',
    sharedLinks: [
      { id: 'l_fr1', url: 'https://kyivmaps.com/places/b-fresh', title: 'B Fresh Концепт-маркет та тераса', domain: 'kyivmaps.com', timestamp: '18:42', senderName: 'Марта' }
    ],
    sharedMediaCount: {
      photos: 128,
      files: 5,
      links: 74,
      audio: 32,
      tables: 9,
    },
    members: [
      {
        id: 'user_me',
        name: 'Кирило Милосердов',
        handle: '@kirill_m',
        avatar: '',
        role: 'owner',
        customTitle: 'Маршрутний гід',
        statusText: 'Шукаю нову фільтр-каву',
        isOnline: true,
        phone: '+380 97 452 1890',
        bio: 'Дизайнер та кавовий ентузіаст.',
      },
      {
        id: 'u_marta',
        name: 'Марта Шевченко',
        handle: '@marta_art',
        avatar: '',
        role: 'admin',
        customTitle: 'Фотограф & Куратор',
        statusText: 'На терасі, фотографую світло 📷',
        isOnline: true,
        phone: '+380 66 778 9900',
        bio: 'Фотографії Києва, плівка 35мм, виставки сучасного мистецтва.',
      },
      {
        id: 'u_taras',
        name: 'Тарас Бойко',
        handle: '@taras_b',
        avatar: '',
        role: 'member',
        customTitle: 'Бариста-майстер',
        statusText: 'Паркуюся біля Змієнка 🚗',
        isOnline: true,
        phone: '+380 98 665 4433',
        bio: 'Кавовий експерт, обсмажування зерен, велоподорожі.',
      },
      {
        id: 'u_solomiya',
        name: 'Соломія Коч',
        handle: '@solomia_k',
        avatar: '',
        role: 'member',
        customTitle: 'Архітектор просторів',
        statusText: 'В дорозі на Поділ',
        isOnline: false,
        phone: '+380 50 443 2211',
        bio: 'Ландшафтний дизайн, реновація старих будівель.',
      },
    ],
    messages: [
      {
        id: 'msg_k1',
        senderId: 'u_marta',
        senderName: 'Марта Шевченко',
        senderAvatar: '',
        timestamp: '18:40',
        type: 'text',
        text: 'Друзі, сьогодні неймовірний вечір! Ми вже забронювали затишний столик на терасі 🌸',
      },
      {
        id: 'msg_k2',
        senderId: 'u_marta',
        senderName: 'Марта Шевченко',
        senderAvatar: '',
        timestamp: '18:42',
        type: 'location',
        locationData: {
          name: 'B Fresh',
          category: 'магазин · продукти · 129 км · ≈ 2071 хв пішки',
          address: 'Вулиця Всеволода Змієнка (Київ)',
          distance: '129 км',
          walkingTime: '≈ 2071 хв пішки',
          coords: { lat: 50.4501, lng: 30.5234 },
          hours: '08:30 – 22:00',
          dossier: {
            title: 'B Fresh',
            category: 'магазин · продукти · концепт-кафе',
            address: 'Вулиця Всеволода Змієнка (Київ)',
            vibe: 'Сучасний концепт-маркет з фермерськими товарами, спешелті кавою та теплою терасою.',
            bestHours: '08:30 – 22:00 (Спокійний період: 12:00 – 16:00)',
            crowdLevel: 'Помірний',
            atmosphere: ['🌿 Органічні продукти', '🥐 Свіжі круасани', '☕ Specialty Coffee', '🐕 Pet-friendly'],
            transitTips: 'Вулиця Всеволода Змієнка. 8 хв від зупинки громадського транспорту.',
            recommendations: 'Обов’язково скуштуйте свіжі круасани з мигдалем та холодний тархун.',
          },
        },
      },
      {
        id: 'msg_k3',
        senderId: 'u_taras',
        senderName: 'Тарас Бойко',
        senderAvatar: '',
        timestamp: '18:45',
        type: 'split-bill',
        splitBillData: {
          title: 'Спільне замовлення напоїв та десертів ☕🥐',
          totalAmount: 640,
          currency: '₴',
          paidCount: 2,
          participants: [
            { id: 'p1', name: 'Тарас (Оплатив)', avatar: '', share: 215, paid: true },
            { id: 'p2', name: 'Марта', avatar: '', share: 215, paid: true },
            { id: 'p3', name: 'Кирило', avatar: '', share: 210, paid: false },
          ],
        },
      },
      {
        id: 'msg_k4',
        senderId: 'user_me',
        senderName: 'Кирило Милосердов',
        senderAvatar: '',
        timestamp: '18:48',
        type: 'multi-quote',
        isSelf: true,
        text: 'Звів домовленості по нашій зустрічі:',
        multiQuoteData: {
          title: 'План вечора та координація',
          quotes: [
            { id: 'q1', senderName: 'Марта', timestamp: '18:40', text: 'Ми вже забронювали затишний столик на терасі 🌸' },
            { id: 'q2', senderName: 'Тарас', timestamp: '18:45', text: 'Спільне замовлення напоїв та десертів ☕🥐' },
          ],
          synthesis: {
            keyPoints: [
              'Локація підтверджена: затишна тераса B Fresh біля Всеволода Змієнка.',
              'Рахунок розподілено на 3 рівні частки (215 ₴ / 210 ₴).',
              'Основний збір заплановано на 19:15.',
            ],
            conclusion: 'Усі організаційні моменти закриті.',
            actionItem: 'Підтвердити оплату частки та відпочити у колі друзів.',
          },
        },
      },
    ],
  },

  // 4. STUDY CIRCLE: Архітектура та Міські Дослідження 🎓
  {
    id: 'chat_architecture_study',
    title: 'Архітектура та Міські Дослідження 🎓',
    avatar: '',
    type: 'group',
    circle: 'study',
    badge: 'Курс 2026',
    unreadCount: 3,
    membersCount: 12,
    customVibe: 'Сеisation, дослідницькі семінари, література та розрахунки просторів',
    description: 'Група досліджень адаптивної архітектури та міського простору.',
    topic: 'Моделювання пішохідних потоків та безбар’єрність',
    sharedMediaCount: {
      photos: 88,
      files: 34,
      links: 41,
      audio: 6,
      tables: 11,
    },
    members: [
      {
        id: 'u_prof_andriy',
        name: 'Андрій Васильович',
        handle: '@prof_andriy',
        avatar: '',
        role: 'owner',
        customTitle: 'Куратор програми',
        statusText: 'Приймаю есе з урбаністики',
        isOnline: true,
      },
      {
        id: 'user_me',
        name: 'Кирило Милосердов',
        handle: '@kirill_m',
        avatar: '',
        role: 'member',
        customTitle: 'Дослідник',
        statusText: 'Аналіз просторових даних',
        isOnline: true,
      },
    ],
    messages: [
      {
        id: 'msg_st1',
        senderId: 'u_prof_andriy',
        senderName: 'Андрій Васильович',
        senderAvatar: '',
        timestamp: '14:20',
        type: 'text',
        text: 'Шановні колеги! До четверга прохання заповнити порівняльну таблицю аналізу ревіталізації промислових зон.',
      },
      {
        id: 'msg_st2',
        senderId: 'user_me',
        senderName: 'Кирило Милосердов',
        senderAvatar: '',
        timestamp: '14:45',
        type: 'table',
        isSelf: true,
        text: 'Підготував базову структуру для порівняння локацій:',
        tableData: {
          title: 'Порівняльний аналіз ревіталізації промислових зон Києва',
          description: 'Оцінка доступності, озеленення та комерційного потенціалу',
          columns: [
            { key: 'location', label: 'Локація / Об’єкт', type: 'text' },
            { key: 'area', label: 'Площа (га)', type: 'number' },
            { key: 'greenScore', label: 'Озеленення (%)', type: 'number' },
            { key: 'stage', label: 'Стадія проєкту', type: 'badge' },
          ],
          rows: [
            { id: 'r1', location: 'Територія заводу Ріхерта (Поділ)', area: 12.4, greenScore: 45, stage: 'Концепція' },
            { id: 'r2', location: 'Промзона Теличка', area: 85.0, greenScore: 20, stage: 'Дослідження' },
            { id: 'r3', location: 'Арт-завод Платформа', area: 18.2, greenScore: 60, stage: 'Реалізовано' },
          ],
        },
      },
    ],
  },

  // 5. COMMUNITIES CIRCLE: Київський Клуб Урбаністики 🌿
  {
    id: 'chat_urban_club',
    title: 'Київський Клуб Урбаністики 🌿',
    avatar: '',
    type: 'channel',
    circle: 'communities',
    badge: 'Спільнота',
    unreadCount: 4,
    membersCount: 342,
    customVibe: 'Пішохідні зони, велоінфраструктура та збереження історичної спадщини',
    description: 'Відкрита спільнота архітекторів, урбаністів та активних містян Києва.',
    topic: 'Обговорення безбар’єрного доступу на Подолі',
    sharedMediaCount: {
      photos: 310,
      files: 45,
      links: 210,
      audio: 12,
      tables: 28,
    },
    messages: [
      {
        id: 'msg_u1',
        senderId: 'u_urban_lead',
        senderName: 'Остап Урбанський',
        senderAvatar: '',
        timestamp: '14:00',
        type: 'poll',
        pollData: {
          question: 'Яка вулиця на вашу думку потребує пріоритетного розширення пішохідної зони?',
          totalVotes: 89,
          options: [
            { id: 'op1', text: 'вул. Петра Сагайдачного (Поділ) 🚶‍♂️', votes: 42, voters: [] },
            { id: 'op2', text: 'вул. Рейтарська (Золоті Ворота) 🌳', votes: 31, voters: [] },
            { id: 'op3', text: 'вул. Всеволода Змієнка 🚲', votes: 16, voters: [] },
          ],
        },
      },
    ],
  },

  // 6. SAVED CIRCLE: Особисті нотатки & Збережене 🔖
  {
    id: 'chat_saved_notes',
    title: 'Особисті нотатки & Збережене 🔖',
    avatar: '',
    type: 'dm',
    circle: 'saved',
    badge: 'Хмара',
    unreadCount: 0,
    customVibe: 'Твої ідеї, збережені таблиці, код, посилання та аудіо-замітки',
    description: 'Особистий простір для збереження важливих думок та файлів.',
    sharedMediaCount: {
      photos: 14,
      files: 9,
      links: 35,
      audio: 18,
      tables: 5,
    },
    messages: [
      {
        id: 'msg_s1',
        senderId: 'user_me',
        senderName: 'Кирило Милосердов',
        senderAvatar: '',
        timestamp: 'Вчора',
        type: 'text',
        isSelf: true,
        text: 'Головне правило: органічний месенджер не повинен бути сухою оболонкою. Він має бути як улюблений блокнот і живий кабінет — з таблицями, розумним структуруванням, колами спілкування та теплим відчуттям дотику.',
        reactions: [{ emoji: '🧡', count: 1, users: ['user_me'] }],
      },
    ],
  },
  // 7. DIRECT P2P CHATS
  {
    id: 'chat_dm_kyrylo',
    title: 'Kyrylo',
    handle: '@kyrylo',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&auto=format&fit=crop&q=80',
    type: 'dm',
    circle: 'friends',
    badge: 'P2P Mesh',
    unreadCount: 0,
    isOnline: true,
    peerNodeId: 'node_kyrylo',
    customVibe: 'Прямий шифрований P2P канал звʼязку',
    description: 'Прямий децентралізований діалог через протокол PHANTOM Mesh.',
    messages: [],
  },
  {
    id: 'chat_dm_kiril',
    title: 'Kiril',
    handle: '@kiril',
    avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=200&auto=format&fit=crop&q=80',
    type: 'dm',
    circle: 'friends',
    badge: 'P2P Mesh',
    unreadCount: 0,
    isOnline: true,
    peerNodeId: 'node_kiril',
    customVibe: 'Прямий шифрований P2P канал звʼязку',
    description: 'Прямий децентралізований діалог через протокол PHANTOM Mesh.',
    messages: [],
  },
];

export const initialSmartFolders: SmartFolder[] = [
  {
    id: 'all',
    name: 'Усі',
    emoji: '✨',
    color: '#1F2521',
    vibe: 'Повний хаб',
    isBuiltIn: true,
    chatIds: [],
  },
  {
    id: 'folder_project_alpha',
    name: 'Project Alpha',
    emoji: '🚀',
    color: '#E87A42',
    vibe: '⚡ Deep Work & Design Sprint',
    isMuted: false,
    chatIds: ['chat_aura_design', 'chat_saved_notes'],
    filterRules: {
      includeCircles: ['work', 'saved'],
    },
  },
  {
    id: 'folder_private_interests',
    name: 'Private Interests',
    emoji: '🌿',
    color: '#528A4B',
    vibe: '☕ Urban Chill & Specialty',
    isMuted: false,
    chatIds: ['chat_kyiv_explorers', 'chat_urban_club', 'chat_urban_studio'],
    filterRules: {
      includeCircles: ['friends', 'communities', 'study'],
    },
  },
  {
    id: 'folder_family_hearth',
    name: 'Родина & Дім',
    emoji: '🏡',
    color: '#D97706',
    vibe: '💛 Теплий дім & плани',
    isMuted: false,
    chatIds: ['chat_family_hearth'],
    filterRules: {
      includeCircles: ['family'],
    },
  },
  {
    id: 'folder_action_tasks',
    name: 'Задачі & Спринти',
    emoji: '⚡',
    color: '#8C461A',
    vibe: '🎯 Пріоритетні дії',
    isMuted: false,
    chatIds: ['chat_aura_design', 'chat_urban_studio'],
    filterRules: {
      unreadOnly: false,
    },
  },
];

export const initialScheduledMessages: ScheduledMessage[] = [
  {
    id: 'sched_1',
    chatId: 'chat_aura_design',
    chatTitle: 'Aura Studio & Core Team',
    chatAvatar: '',
    senderId: 'user_me',
    senderName: 'Кирило Милосердов',
    scheduledTime: 'Сьогодні о 18:00',
    scheduledDate: '2026-08-19',
    scheduledExactTime: '18:00',
    createdAt: '10:45',
    type: 'text',
    text: '🚀 Нагадування: Фінальний білд та підготовка реліз-ноутс для sprint v2.5. Перевірте статус у тасці перед деплоєм.',
  },
  {
    id: 'sched_2',
    chatId: 'chat_family_hearth',
    chatTitle: 'Родинне коло 🏡',
    chatAvatar: '',
    senderId: 'user_me',
    senderName: 'Кирило',
    scheduledTime: 'Завтра о 09:30',
    scheduledDate: '2026-08-20',
    scheduledExactTime: '09:30',
    createdAt: '11:10',
    type: 'text',
    text: 'Доброго ранку усім! ☕ Замовляю свіжі круасани та каву на суботу, напишіть хто що обирає.',
  },
  {
    id: 'sched_3',
    chatId: 'chat_kyiv_explorers',
    chatTitle: 'Київські дослідники ☕',
    chatAvatar: '',
    senderId: 'user_me',
    senderName: 'Кирило',
    scheduledTime: 'П’ятниця о 17:30',
    scheduledDate: '2026-08-21',
    scheduledExactTime: '17:30',
    createdAt: '09:15',
    type: 'text',
    text: '🌿 Зустрічаємось біля «Каштану» на Рейтарській, столик на терасі заброньовано на 18:00.',
  },
  {
    id: 'sched_4',
    chatId: 'chat_aura_design',
    chatTitle: 'Aura Studio & Core Team',
    chatAvatar: '',
    senderId: 'user_me',
    senderName: 'Кирило Милосердов',
    scheduledTime: 'Понеділок о 10:00',
    scheduledDate: '2026-08-24',
    scheduledExactTime: '10:00',
    createdAt: 'Вчора о 16:20',
    type: 'task-list',
    text: '📋 План запуску нового тижня:',
    taskListData: {
      title: 'План пріоритетів на тиждень',
      tasks: [
        { id: 't_s1', title: 'Огляд користувацьких фідбеків', completed: false, assigneeName: 'Кирило' },
        { id: 't_s2', title: 'Оптимізація бази та кешування', completed: false, assigneeName: 'Олексій' },
        { id: 't_s3', title: 'Фінальний рев’ю доступності WCAG', completed: false, assigneeName: 'Дарина' },
      ],
    },
  },
];

export const smartFolders = initialSmartFolders;
export const scheduledMessages = initialScheduledMessages;

